import { Action, Dispatch } from 'redux'
import { FirebaseDocChangeType } from 'firebase/index'
import { StockType } from 'types/stock'
import { fetchStocksAction } from 'reducks/stock/actions'

const mergeListeningStocks = (
  changes: FirebaseDocChangeType[],
  currentStocks: StockType[],
  dispatch: Dispatch<Action>,
  isExcludingDeletedStock: boolean
): void => {
  let stocks: StockType[] = currentStocks
  for (let i = 0; i < changes.length; i = (i + 1) | 0) {
    const change = changes[i]
    const data = change.doc.data() as StockType
    data.stock_ref = change.doc.ref
    if (change.type === 'added') {
      // すでに同じ在庫IDが存在する場合は追加しない（重複対策）
      if (stocks.some((stock) => stock.stock_ref?.id === data.stock_ref?.id)) continue
      // 論理削除された在庫は追加しない
      if (isExcludingDeletedStock && data.is_deleted) continue
      stocks.push(data)
    } else if (change.type === 'modified') {
      const index = stocks.findIndex((stock) => stock.stock_ref?.id === data.stock_ref?.id)
      // modifiedだが新規追加
      if (index === -1) {
        // すでに同じ在庫IDが存在する場合は追加しない（重複対策）
        if (stocks.some((stock) => stock.stock_ref?.id === data.stock_ref?.id)) continue
        // 論理削除された在庫は追加しない
        if (isExcludingDeletedStock && data.is_deleted) continue
        stocks.push(data)
      } else {
        stocks[index] = data
      }
    } else if (change.type === 'removed') {
      stocks = stocks.filter((stock) => stock.stock_ref?.id !== data.stock_ref?.id)
    }
  }
  if (stocks.length > 0) {
    dispatch(fetchStocksAction(stocks))
  }
}

export default mergeListeningStocks
